module.exports = __webpack_public_path__ + "img/Diano.d80ba82.png";